import { onDestroy } from "svelte";
import { getProductPrices } from "./priceCalculator";
export const setFocus = (target, delay = true) => {
    let timeout;
    if (delay) {
        timeout = setTimeout(() => {
            target.focus();
        }, 800);
    }
    else {
        target.focus();
    }
    onDestroy(() => {
        if (delay) {
            clearTimeout(timeout);
        }
    });
};
export const getBorderColors = (error, empty, disabled) => {
    // let border = "ring-0 focus:ring-0"
    if (disabled)
        return "";
    let border = " ";
    if (error && !empty)
        return `focus:ring-4 ring-2 focus:ring-Red800 ring-Red800 ${border}`;
    border += "focus:ring-2 ";
    border += empty ? "focus:ring-Violet400" : "focus:ring-Green900 outline-none";
    return `${border} ${empty ? "ring-2 ring-Yellow" : "border border-Neutral400"}`;
};
export const readCookie = (name) => {
    try {
        let cookie = {};
        document.cookie.split(";").forEach(function (el) {
            const equalIndex = el.indexOf("=");
            if (equalIndex !== -1) {
                const k = el.substring(0, equalIndex).trim();
                const v = el.substring(equalIndex + 1);
                cookie[k] = v;
            }
        });
        return cookie[name];
    }
    catch (e) {
        return null;
    }
};
export const getAdvertSourceFromCookie = () => {
    const sourceQuery = readCookie("source_query");
    if (!sourceQuery) {
        return "";
    }
    try {
        const decodedQuery = decodeURIComponent(sourceQuery);
        const urlParams = new URLSearchParams(decodedQuery);
        const advertSource = urlParams.get("AdvertSource");
        return advertSource || "";
    }
    catch (error) {
        console.warn("Failed to parse source_query cookie:", error);
        return "";
    }
};
export const getAvaliableProducts = (data, estimation, showFixed = true, showVariable = true, showHourly = true) => {
    const products = getProductPrices(data.result, estimation);
    if (!showFixed && products?.fixedProducts) {
        delete products["fixedProducts"];
    }
    if (!showVariable && products?.variableProducts) {
        delete products["variableProducts"];
    }
    if (!showHourly && products?.hourlyProducts) {
        delete products["hourlyProducts"];
    }
    return products;
};
export const getDefaultProductOrder = () => ["variable", "hourly", "fixed"];
export const getSummary = (context, seller, invoiceValue, facility, isMoving) => {
    let summary = {
        pin: context.person.socialSecurity,
        email: context.person.email,
        phone: context.person.mobile,
        firstname: context.person.firstname,
        lastname: context.person.lastname,
        deliveryAddress: context.facilityInformation.address,
        deliveryCity: context.facilityInformation.city,
        deliveryZipcode: parseInt(context.facilityInformation.zipcode),
        address: context.person.address,
        zipcode: context.person.zipcode,
        isMovingIn: isMoving ? true : false,
        city: context.person.city,
        residenceType: context.facilityInformation.residenceType,
        startDate: toLocalDateString(context.startDate),
        authority: context.facility.powerOfAttorney,
        terms: false,
        estimation: context.estimation,
        invoiceDistId: context.invoice.id,
        additionalProduct: context.additionalProducts ?? [],
        product: context.selectedProductId,
        fetchPersonInfo: context.hasFetchedPersonAutomatic,
        fetchBillingInfo: context.hasFetchedPersonAutomatic &&
            context.person.address === context.facilityInformation.address,
        signWithQRCode: context.signWithQRCode,
        AdvertSource: getAdvertSourceFromCookie(),
    };
    if (context.facilityInformation.propertyOwner) {
        summary.propertyOwner = context.facilityInformation.propertyOwner;
    }
    if (context.facilityInformation.residenceType === "apartment") {
        if (context.facilityInformation.apartmentNumber) {
            summary.apartmentNumber = context.facilityInformation.apartmentNumber;
        }
        if (context.facilityInformation.formerResidence) {
            summary.formerResidence = context.facilityInformation.formerResidence;
        }
    }
    if (context?.companyInformation?.address) {
        summary.address = context?.companyInformation?.address;
        summary.zipcode = context?.companyInformation?.zipcode;
        summary.city = context?.companyInformation?.city;
    }
    else {
        summary.address = context.person.address;
        summary.zipcode = context.person.zipcode;
        summary.city = context.person.city;
    }
    if (seller)
        summary.seller = seller;
    if (invoiceValue)
        summary.invoiceDistValue = invoiceValue;
    if (!summary.authority && facility) {
        summary.facilityId = "735999" + facility.facilityId;
        summary.areaId = facility.areaId;
    }
    if (context.extraField) {
        summary.extra = context.extraField;
    }
    return summary;
};
export const hideHTMLElement = (el) => {
    if (el)
        el.classList.add("invisible");
};
export const showHTMLElement = (el) => {
    if (el)
        el.classList.remove("invisible");
};
export const decodeEntities = (encodedString) => {
    let textarea = document.createElement("textarea");
    textarea.innerHTML = encodedString;
    return textarea.value;
};
export const setJS = (content) => {
    content = decodeEntities(content);
    const scriptRegex = /<script(?:\s+[a-zA-Z]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^>\s]+))?)*>([\s\S]*?)<\/script>/gis;
    const srcScriptRegex = /<script\s+src=(?:"([^"]*)"|'([^']*)'|([^>\s]+))[^>]*><\/script>/gis;
    let scriptContent = "";
    let externalScripts = [];
    if (content) {
        const matches = content.matchAll(scriptRegex);
        for (const match of matches) {
            scriptContent += match[1].replace(/<\/?p>/g, "") + "\n";
        }
        const srcMatches = content.matchAll(srcScriptRegex);
        for (const srcMatch of srcMatches) {
            const [, doubleQuoted, singleQuoted, unquoted] = srcMatch[0].match(/src="([^"]*)"|src='([^']*)'|src=([^>\s]+)/) ?? [];
            let src = doubleQuoted || singleQuoted || unquoted;
            src = src.replace(/”|“/g, "");
            externalScripts.push(src);
        }
    }
    if (scriptContent) {
        scriptContent = scriptContent.replace(/”|“/g, '"');
        const script = document.createElement("script");
        script.innerHTML = scriptContent;
        document.body.appendChild(script);
    }
    if (externalScripts.length > 0) {
        externalScripts.forEach((src) => {
            const script = document.createElement("script");
            script.src = src;
            document.body.appendChild(script);
        });
    }
};
export const toLocalDateString = (date) => new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000).toISOString().split("T")[0];
export const getFirstPossibleDate = (days) => {
    let firstPossibleDate = new Date(new Date().setDate(new Date().getDate() + days));
    firstPossibleDate.setHours(0, 0, 0, 0);
    return firstPossibleDate;
};
export const checkDeviceType = () => {
    const userAgent = navigator.userAgent;
    if (/Android/i.test(userAgent)) {
        return "Android";
    }
    else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return "iOS";
    }
    else if (/Windows Phone/i.test(userAgent)) {
        return "Windows Phone";
    }
    return "Desktop";
};
export const getBankIdUrl = (token) => {
    if (checkDeviceType() === "Desktop") {
        return `bankid:///?autostarttoken=${token}&redirect=null`;
    }
    return `https://app.bankid.com/?autostarttoken=${token}&redirect=null`;
};
/**
 * Platform default for the initial BankID device mode. Desktop scans a QR from
 * a phone; mobile autostarts straight into the app on the same device.
 * Returns the value for `withQRCode` (true = QR / "other device").
 */
export const defaultBankIdDevice = () => checkDeviceType() === "Desktop";
/** Collapse a BankID controller status into the BankIDPrompt `state` prop. */
export const toPromptState = (status) => {
    switch (status) {
        case "starting":
            return "loading";
        case "failed":
            return "error";
        case "idle":
            return "idle";
        default:
            return "pending"; // pending, success, cancelled (screen unmounts on the last two)
    }
};
